/* eslint-disable react-hooks/exhaustive-deps */
/* https://swiperjs.com/react */
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { IMedia, WINDOW_WIDTH } from '@libs/interfaces/layouts';
import useScreenSize from '@/modules/pe-basic-module/hooks/useScreenSize'; 
import { default as UUID } from "node-uuid";
import { createRef, CSSProperties, useEffect, useRef, useState } from 'react';
import GalleryDialog from './GalleryDialog';
import GalleryItem from './GalleryItem';
import Next from './Next';
import Prev from './Prev';
import To from './To';
import "./style.scss";
import PrevButton from './PrevButton'; 
import NextButton from './NextButton'; 
import { getWindowWidthFromElementWidth } from 'src/libs/utilities';

const { Autoplay, Navigation, Pagination, Scrollbar, A11y, EffectFade } =  require("swiper/modules")  
const { Swiper, SwiperSlide } =  require("swiper/react")  

export interface IMediaSizes {
    [WINDOW_WIDTH.PANEL]    : number
    [WINDOW_WIDTH.LARGE]    : number
    [WINDOW_WIDTH.SCREEN]   : number
    [WINDOW_WIDTH.TABLET]   : number
    [WINDOW_WIDTH.MOBILE]   : number
    [WINDOW_WIDTH.SMALL]    : number
}
export enum NAVIGATION_TYPE {
    // DEFAULT="no figure",
    ROUND="round",
    SQUARE="square",
}
export enum NAVIGATION_THEME_TYPE {
    DEFAULT="transparent",
    LIGHT="light",
    DARK="dark",
    RED="red",
    GREEN="green",
}
export enum NAVIGATION_DESIGN_TYPE {
    CHEVRON="chevron",
    CARET="caret",
    ARROW="arrow",
    LONG_ARROW="long-arrow-alt",
    HAND_POINT="hand-point",
}
export enum NAVIGATION_SIZE_TYPE {
    DEFAULT="small-size",
    NORMAL="normal",
    LARGE="large",
    GIANT="giant",
}
export enum PAGINATION_TYPE {
    DEFAULT="DEFAULT",
    ROUND="ROUND", 
    SQUARE="SQUARE", 
    RECT="RECT",
}

export enum NAVIGATION_POSITION_TYPE {
    TOP_LEFT="top-left-",
    TOP_RIGHT="top-right-",
    TOP_CENTER="top-center-",
    MIDDLE_OUTER="middle-outer-",
    MIDDLE_INNER="middle-inner-",
}
export interface IGalleryProps {
    i?: number
    items: ( IMedia | URL | string | Element | any )[]
    itemWidth:number | string
    itemHeight?:number | string
    itemStyle?: CSSProperties
    count?: number | IMediaSizes | "auto"
    autoplay?: number
    start?: number
    loop?:boolean
    navigation?:boolean
    pagination?:boolean
    autoHeight?: boolean
    padding?: number
    type?: "image" | "div" | "span" | "element"
    navigationType?: NAVIGATION_TYPE 
    navigationThemeType?: NAVIGATION_THEME_TYPE
    navigationSizeType?: NAVIGATION_SIZE_TYPE
    navigationDesignType?: NAVIGATION_DESIGN_TYPE
    navigationPositionType?: NAVIGATION_POSITION_TYPE
    paginationType?: PAGINATION_TYPE
    galleryContainerClassName?: string
    onPrev?: ( ) => void
    onNext?: ( ) => void
    on?: ( i : number ) => void
}
export const Gallery = ({items, itemWidth, itemHeight, ...props}:IGalleryProps) => {
    const sizes = useScreenSize()
    const [ demention, setDemention ] = useState<keyof typeof WINDOW_WIDTH>( "LARGE" )
    const [ isOpen, setIsOpen ] = useState( false )
    const [ i, setI ] = useState(props.i || 0)
    const [ start, setStart ] = useState<number>( props.start || 0 )
    const prv = createRef()
    const nxt = createRef()
    const txo = createRef()
    const ref = useRef(null);
    const progressCircle = useRef(null);
    const progressContent = useRef(null);
    const data: IMedia[ ] = items.map((item : IMedia | URL | string | Element | any) => {
        if( typeof item === "string" ) {
            return { 
                id: Math.random() + "", 
                title: "", 
                post_content: item, 
                thumbnail: item 
            } as IMedia
        }
        return item as IMedia
    }) || []
    const count = !!props.count
        ?
        typeof props.count === "number"
            ?
            props.count
            :
            ( props.count as IMediaSizes )[ WINDOW_WIDTH[ demention ] ]
        :
        1
    const to = (i:number) => {
        setI(i)
        setIsOpen( true )
    }  
    const onPrev2 = () => {
        (prv.current! as any).click() 
        setStart( start - 1 )
    }
    const onNext2 = () => {
        (nxt.current! as any).click() 
        setStart( start + 1 )
    }
    const onPrev = () => { 
        setStart( start - 1 )
        if(props.on) props.on( (start - 1) % items.length )
    }
    const onNext = () => { 
        setStart( start + 1 )
        if(props.on) props.on( (start + 1) % items.length )
    }
    const onTo = ( i: number ) => {
        (txo.current! as any).click() 
        setStart( i )
    }
    const pagination = {
        clickable: true, 
        // dynamicBullets: true, 
        renderBullet: function (index: number, className: string) {
          return '<span class="pe-gallery-nav-dot ' + className + '"> </span>';
        },
    }
    const onAutoplayTimeLeft = (s: any, time: number, progress: number) => {
        if( progressCircle.current &&  progressContent.current) {
            (progressCircle.current as any).style.setProperty('--progress', 1 - progress);
            (progressContent.current as HTMLSpanElement).textContent = `${Math.ceil(time / 1000)}s`
        }
    }
    useEffect(() => {
        onTo( props.start || 0 ) 
    }, [])
    useEffect(() => { 
        if(ref.current) {
            const bounds = ( ref.current as HTMLDivElement ).getBoundingClientRect()
            const width = bounds.width
            setDemention( getWindowWidthFromElementWidth( width ) )
        }
    }, [ sizes.width ])
    return <div 
        className={`gallery position-relative pagination-${ props.paginationType?.toString().toLowerCase().replaceAll("_", "-") } ${ props.navigationPositionType || "" } ${ props.navigationSizeType || ""}  ${props.galleryContainerClassName}`}
        style={{height: itemHeight, minHeight: itemHeight }}
        ref={ref}
        data-slides-per-view={ count }
    >
        <Swiper
            // install Swiper modules
            modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y, EffectFade ] }  
            spaceBetween={props.padding}  
            loop={props.loop} 
            loopAddBlankSlides 
            watchSlidesProgress
            slidesPerView={ count } 
            pagination={ props.pagination ? pagination : false } 
            direction={'horizontal'} 
            mousewheel
            autoHeight={props.autoHeight}
            autoplay={ 
                props.autoplay 
                    ?
                    {
                        delay: props.autoplay,
                        disableOnInteraction: true,
                    }
                    :
                    false
            }
            onAutoplayTimeLeft={onAutoplayTimeLeft} 
        >
            {
                data.map((item, i) => {
                    return <SwiperSlide key={i}>
                        <GalleryItem
                            i={ i }
                            url={ item }
                            key={ i }
                            galleryId={ UUID.v4() }
                            gallery={ data }
                            width={ itemWidth }
                            height={ itemHeight }
                            to={ to }
                            type={ props.type || "div"}
                            padding={props.padding}
                            style={props.itemStyle}
                        />
                    </SwiperSlide>    
                })
            } 
            <Prev onClick={onPrev} ref={prv}/> 
            <Next onClick={onNext} ref={nxt}/> 
            <To onClick={onTo} ref={txo} to={start} />
            {/* <div className="autoplay-progress" slot="container-end">
                <svg viewBox="0 0 48 48" ref={progressCircle}>
                    <circle cx="24" cy="24" r="20"></circle>
                </svg>
                <span ref={progressContent}></span>
            </div>*/} 
        </Swiper>   
        { 
            (( data.length > count && start > 0 ) || props.loop) && props.navigation && data.length > 0 &&
            <PrevButton 
                onClick={onPrev2} 
                navigationType={props.navigationType || NAVIGATION_TYPE.SQUARE}
                navigationThemeType={props.navigationThemeType || NAVIGATION_THEME_TYPE.DEFAULT}
                navigationPositionType={props.navigationPositionType}
                navigationSizeType={props.navigationSizeType}
                navigationDesignType={props.navigationDesignType}
            /> 
        }
        { 
            ( start < data.length - count  || props.loop ) && props.navigation && data.length > 0 &&
            <NextButton 
                onClick={onNext2} 
                navigationType={props.navigationType || NAVIGATION_TYPE.SQUARE}
                navigationThemeType={props.navigationThemeType || NAVIGATION_THEME_TYPE.DEFAULT}
                navigationPositionType={props.navigationPositionType}
                navigationSizeType={props.navigationSizeType}
                navigationDesignType={props.navigationDesignType}
            />
        }
        <GalleryDialog
            i={ i }
            data={ data }
            setI={ to }
            isOpen={ isOpen }
            setIsOpen={ setIsOpen }
        /> 
    </div>
};